<template>
    <section class="early-access--bg">
      <div class="container early-access">
        <div class="early-access__content">
          <h3 class="early-access__title">Get early access today</h3>
          <p class="early-access__text">
            It only takes a minute to sign up and our free starter tier is
            extremely generous. If you have any questions, our support team would
            be happy to help you.
          </p>
        </div>
        <form class="hero__form form" @submit="onSubmit">
            <input
                class="form__input input"
                v-model="email"
                @change="handleChange"
                placeholder="Enter your email"
                :style="showError && 'border: 2px solid red;'"
            />
            <span class="form__error" v-if="showError">{{error}}</span>
            <button class="form__button button" type="submit">get started</button>
        </form>
      </div>
    </section>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      error: 'Please check your email',
      showError: false,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.emailIsValid(this.email) && this.email) this.showError = true;
      else this.showError = false;
    },
    handleChange(evt) {
      this.email = evt.target.value;
    },
    emailIsValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
.early-access {
    &--bg {
        padding: var(--bg-spacer) 0;
        background-color: var(--desaturated-blue);
        color: var(--white);
    }

    @media (min-width: 90em) {
      display: flex;
      justify-content: space-between;
      text-align: initial;
    }

    &__content {
      @media (min-width: 90em) {
        width: 45%;
      }
    }

    &__title {
      font-size: var(--fs-h2);
      font-weight: var(--fw-600);
      @media (min-width: 90em) {
        font-size: var(--fs-h1);
      }
    }

    &__text {
      max-width: 55ch;
      margin: calc(var(--sm-spacer) / 1.5) auto 0 auto;
      @media (min-width: 90em) {
        font-size: var(--fs-h3);
        margin-left: 0;
        margin-right: 0;
      }
    }

    .form {
      margin-top: calc(var(--sm-spacer) / 1.3);
      align-self: flex-start;

      &__button, .button, .input, &__input {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        display: block;
        font-family: var(--ff-alt);
        border-radius: var(--border-radius);
        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
      }

      &__email {
        font-size:var(--fs-h3);
      }

      &__input, .input {
        @media (min-width: 90em) {
          grid-area: a;
        }
      }

      &__button, .button {
        @media (min-width: 90em) {
          width: max-content;
          margin-left: 0;
          margin-right: 0;
          grid-area: b;
        }
      }

      &__error {
        color: red;
        grid-area: c;
        align-self: flex-end;
      }

      &__button {
        margin-top: calc(var(--sm-spacer) / 3);
        font-weight: var(--fw-600);
        background-color: var(--bright-blue);
        color: var(--light-grayish-blue);
        border: 2px solid var(--bright-blue);
        &:hover, &:focus {
          color: var(--bright-blue);
          background-color: var(--light-grayish-blue);
        }
      }
      @media (min-width: 90em) {
        width: 45%;
        display: grid;
        grid-template-areas: "a a"
                             "c c"
                             "b ."

      }
    }
}
</style>
